var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('youtube',{attrs:{"video-id":_vm.preRegisteredValues}})}
var staticRenderFns = []

export { render, staticRenderFns }